<template>
  <div class="flex items-start">
    <div class="w-64 px-4">
      <img v-if="page.cover" :src="page.cover" class="w-full border rounded" />
      <div v-else class="aspect-ratio-16/9 border rounded w-full bg-gray-200" />
    </div>
    <div class="flex-1 px-4">
      <p class="font-medium">
        {{ page.title }}
      </p>
      <span class="text-xs text-gray-500 font-medium">id: {{ page.id }}</span>
    </div>
    <div class="px-4 flex">
      <a target="_blank" :href="page.url" class="btn btn-ghost px-3">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          class="fill-current"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 3H4C2.897 3 2 3.897 2 5V16C2 17.103 2.897 18 4
            18H11V20H8V22H16V20H13V18H20C21.103 18 22 17.103 22 16V5C22 3.897
            21.103 3 20 3ZM4 14V5H20L20.002 14H4Z"
          />
        </svg>
      </a>
      <!-- Desktop Preview Button -->

      <button
        target="_blank"
        :href="page.url"
        class="btn btn-ghost px-3"
        @click="$emit('page-preview', page)"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          class="fill-current"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17 2H7C5.897 2 5 2.897 5 4V20C5 21.103 5.897 22 7 22H17C18.103 22
            19 21.103 19 20V4C19 2.897 18.103 2 17 2ZM7 16.999V5H17L17.002
            16.999H7V16.999Z"
          />
        </svg>
      </button>
      <!-- Mobile Preview Button -->

      <button class="btn btn-ghost px-3 ml-2" @click="$emit('page-stats', page)">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          class="fill-current"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 11.78L20.24 4.45L21.97 5.45L16.74 14.5L10.23 10.75L5.46
            19H22V21H2V3H4V17.54L9.5 8L16 11.78Z"
          />
        </svg>
      </button>
      <!-- Stats Button -->

      <button class="btn btn-ghost px-3" @click="copyURLToClipboard(page.url)">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          class="fill-current"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 2H10C8.897 2 8 2.897 8 4V8H4C2.897 8 2 8.897 2 10V20C2
            21.103 2.897 22 4 22H14C15.103 22 16 21.103 16
            20V16H20C21.103 16 22 15.103 22 14V4C22 2.897 21.103
            2 20 2ZM4 20V10H14L14.002 20H4ZM20 14H16V10C16 8.897
            15.103 8 14 8H10V4H20V14Z"
          />
        </svg>
      </button>
      <!-- Copy URL Button -->

      <VDropdown v-if="$membershipHasPermissionTo('edit pages,delete pages')" right>
        <template #button="dropdownProps">
          <button class="btn btn-ghost px-3 ml-2" @click="dropdownProps.open">
            <FontAwesomeIcon icon="ellipsis-v" fixed-width />
          </button>
        </template>

        <template #default="dropdownProps">
          <VDropdownMenu>
            <template>
              <a
                v-if="$membershipHasPermissionTo('edit pages')"
                role="button"
                :class="[
                  'block',
                  'px-4',
                  'py-2',
                  'hover:bg-gray-200',
                  'transition-color',
                  'transition-fast',
                  'text-right',
                ]"
                @click="dropdownProps.close(() => $emit('page-edit', page))"
                >Edit</a
              >
              <a
                v-if="$membershipHasPermissionTo('delete pages')"
                role="button"
                :class="[
                  'block',
                  'px-4',
                  'py-2',
                  'hover:bg-gray-200',
                  'transition-color',
                  'transition-fast',
                  'text-right',
                ]"
                @click="dropdownProps.close(() => $emit('page-delete', page))"
                >Delete</a
              >
            </template>
          </VDropdownMenu>
        </template>
      </VDropdown>
    </div>
  </div>
</template>

<script>
import copyToClipboard from '@/utils/copy-to-clipboard';
import VDropdown from '@/components/Common/VDropdown.vue';
import VDropdownMenu from '@/components/Common/VDropdownMenu.vue';

export default {
  components: {
    VDropdown,
    VDropdownMenu,
  },

  props: {
    page: { type: Object, required: true },
  },

  methods: {
    copyURLToClipboard(url) {
      copyToClipboard(url);
    },
    editAction() {
      this.$emit('edit-page', this.page);
    },
    deleteAction() {
      this.$emit('delete-page', this.page);
    },
  },
};
</script>
